import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import {
  Login,
  Dashboard,
  Registrations,
  RegistrationDetail,
  AdminLayout,
  ProtectedRoute,
  AuthProvider,
} from './admin';

// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'aos/dist/aos.css';

// 404 Not Found Component
const NotFound = () => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    textAlign: 'center',
    padding: '20px',
    background: '#f8fafc'
  }}>
    <h1 style={{ fontSize: '72px', color: '#1e293b', margin: 0 }}>404</h1>
    <p style={{ fontSize: '20px', color: '#64748b', marginTop: '10px' }}>Trang không tồn tại</p>
    <a 
      href="/" 
      style={{
        marginTop: '20px',
        padding: '12px 24px',
        background: '#f97316',
        color: 'white',
        textDecoration: 'none',
        borderRadius: '8px',
        fontWeight: '500'
      }}
    >
      Về trang chủ
    </a>
  </div>
);

// Admin 404 Component
const AdminNotFound = () => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    textAlign: 'center',
    padding: '20px',
    background: '#f8fafc'
  }}>
    <h1 style={{ fontSize: '72px', color: '#1e293b', margin: 0 }}>404</h1>
    <p style={{ fontSize: '20px', color: '#64748b', marginTop: '10px' }}>Trang admin không tồn tại</p>
    <a 
      href="/admin/dashboard" 
      style={{
        marginTop: '20px',
        padding: '12px 24px',
        background: '#2563eb',
        color: 'white',
        textDecoration: 'none',
        borderRadius: '8px',
        fontWeight: '500'
      }}
    >
      Về Dashboard
    </a>
  </div>
);

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Website Routes */}
        <Route path="/" element={<HomePage />} />

        {/* Admin Routes - wrapped in AuthProvider */}
        <Route
          path="/admin"
          element={
            <AuthProvider>
              <Navigate to="/admin/dashboard" replace />
            </AuthProvider>
          }
        />
        
        <Route
          path="/admin/login"
          element={
            <AuthProvider>
              <Login />
            </AuthProvider>
          }
        />

        {/* Protected Admin Routes */}
        <Route
          path="/admin"
          element={
            <AuthProvider>
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            </AuthProvider>
          }
        >
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="registrations" element={<Registrations />} />
          <Route path="registrations/:id" element={<RegistrationDetail />} />
          
          {/* Admin 404 - shows 404 page instead of redirect loop */}
          <Route path="*" element={<AdminNotFound />} />
        </Route>

        {/* Global 404 - shows 404 page */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;